import { Form, Input, InputNumber, Radio } from "antd";
import React from "react";
import { Modal } from "react-rainbow-components";
import { uploadImageReturnUrl } from "../../../functions/storage";
import { IProductDetails } from "../../../interfaces/product";
import { createProduct } from "../../../services/product.service";
import { useError } from "../../../store/ErrorModal";
import ImageUploaded from "../ImageUploaded";

import {
  ButtonContainer,
  Container,
  SubmitButton,
  Title,
} from "./index.styles";

type ModalCreateProductProps = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  fetchData: () => void;
};
const ModalCreateProduct: React.FC<ModalCreateProductProps> = (props) => {
  const { isOpen, setIsOpen, fetchData } = props;

  const [form] = Form.useForm<IProductDetails>();
  const typeProduct = Form.useWatch("type", form);

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [blobImage, setBlobImage] = React.useState<File>();
  const { onError } = useError();

  const handleCloseModal = () => setIsOpen(false);

  const handleSubmit = async (value: IProductDetails) => {
    if (!blobImage) return onError("กรุณาเพิ่มรูปภาพสินค้า/โปรโมชั่น");
    try {
      setIsLoading(true);
      const urlImage = blobImage
        ? await uploadImageReturnUrl(blobImage, `/${value["type"]}/`)
        : undefined;
      const payload = { ...value, imageUrl: urlImage, isDeleted: false };
      if (typeProduct === "chat") delete payload["timeRange"];
      if (typeProduct === "video") delete payload["dayRange"];
      await createProduct(payload);
      fetchData();
      handleCloseModal();
    } catch (error: any) {
      onError(error as any);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleCloseModal}
      style={{ padding: "1rem" }}
    >
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <Container>
          <Title>เพิ่มสินค้าใหม่</Title>
          <ImageUploaded handleBlobImage={setBlobImage} />
          <Form.Item
            name="productName"
            label="ชื่อสินค้า"
            rules={[{ required: true, message: "กรุณากรอกชื่อสินค้า" }]}
          >
            <Input placeholder="เพิ่มชื่อสินค้า/โปรโมชั่น" />
          </Form.Item>
          <Form.Item
            name="productDescription"
            label="คำอธิบายสินค้า"
            rules={[{ required: true, message: "กรุณากรอกคำอธิบายสินค้า" }]}
          >
            <Input.TextArea
              showCount
              rows={4}
              maxLength={200}
              placeholder="เพิ่มคำอธิบาย..."
            />
          </Form.Item>
          <Form.Item
            name="price"
            label="ราคา (บาท)"
            rules={[{ required: true, message: "กรุณากรอกราคาสินค้า" }]}
          >
            <InputNumber
              type="number"
              placeholder="ราคา (บาท)"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            name="type"
            label="ประเภทสินค้า"
            rules={[{ required: true, message: "กรุณาเลือกประเภทสินค้า" }]}
          >
            <Radio.Group>
              <Radio value="chat">แชท</Radio>
              <Radio value="video">วิดีโอคอล</Radio>
            </Radio.Group>
          </Form.Item>
          {typeProduct === "chat" && (
            <Form.Item
              name="dayRange"
              label="ช่วงเวลาที่สามารถใช้งานได้ (วัน)"
              rules={[
                {
                  required: true,
                  message: "กรุณาช่วงเวลาที่สามารถใช้งานได้ (วัน)",
                },
              ]}
            >
              <InputNumber
                type="number"
                placeholder="ช่วงเวลาที่สามารถใช้งานได้ (วัน)"
                style={{ width: "100%" }}
              />
            </Form.Item>
          )}
          {typeProduct === "video" && (
            <Form.Item
              name="timeRange"
              label="ช่วงเวลาที่สามารถใช้งานได้ (นาที)"
              rules={[
                {
                  required: true,
                  message: "กรุณาช่วงเวลาที่สามารถใช้งานได้ (นาที)",
                },
              ]}
            >
              <InputNumber
                type="number"
                placeholder="ช่วงเวลาที่สามารถใช้งานได้ (นาที)"
                style={{ width: "100%" }}
              />
            </Form.Item>
          )}
          <ButtonContainer>
            <SubmitButton loading={isLoading}>เพิ่มข้อมูลแพคเกจ</SubmitButton>
          </ButtonContainer>
        </Container>
      </Form>
    </Modal>
  );
};

export default ModalCreateProduct;
